// https://medium.com/trabe/catching-asynchronous-errors-in-react-using-error-boundaries-5e8a5fd7b971
import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import ServedUpError from '../utils/ServedUpError';
import isInlineError from '../utils/isInlineError';

/**
 * A hook that will throw a full page ServedUpError if the error is not passed as one of the
 * inlineErrorCodes in errorCodes.js.
 *
 * @returns {function} - A function that will throw a ServedUpError if the error is not inline.
 */

const useAsyncServedUpError = () => {
  const { venueId } = useParams();
  const [_error, setError] = useState();

  const handleError = useCallback(
    (errorPayload) => {
      if (errorPayload.error.errorCode === 'INVALID_ORDER') {
        window.location.pathname = `/menu/${venueId}`;
        return;
      }
      const isInline = isInlineError(errorPayload);

      if (!isInline) {
        setError(() => {
          throw new ServedUpError(errorPayload);
        });
      }
    },
    [setError, venueId],
  );

  return handleError;
};

export default useAsyncServedUpError;
